module.exports = __webpack_public_path__ + "static/media/Carnet.7b464bcf.svg";